import { isAddress } from 'ethers'

export default isAddress
